import { render, staticRenderFns } from "./fieldsBlockPallet.vue?vue&type=template&id=6f345437&lang=pug"
import script from "./fieldsBlockPallet.vue?vue&type=script&lang=js"
export * from "./fieldsBlockPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports